import { render, staticRenderFns } from "./hrCoreOrg.vue?vue&type=template&id=3960fd2b&scoped=true&"
import script from "./hrCoreOrg.vue?vue&type=script&lang=ts&"
export * from "./hrCoreOrg.vue?vue&type=script&lang=ts&"
import style0 from "./hrCoreOrg.vue?vue&type=style&index=0&id=3960fd2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960fd2b",
  null
  
)

export default component.exports